import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Row,
  Table,
  Space,
  Col,
  Typography,
  Modal,
  Button,
  Select,
  Input,
  Form,
  message,
  TimePicker,
  DatePickerProps,
} from "antd";
import moment from "moment";

import { BatchProcessFileService } from "../services/service";

import { useId24 } from "../../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../../config/app-config";
const appConfig = loadAppConfig();
const { Option } = Select;

const format = "HH:mm";
import dayjs from "dayjs";
import generatePicker from "antd/es/date-picker/generatePicker";
import { config, datePickerTh } from "../../../utils";
import { useLocation } from "react-router-dom";
import { BatchProcessServiceDailyFile } from "../../batchProcessDailyFile/services/service";

const DatePicker = generatePicker(config);

interface Props {
  accessRole: string;
  filter: (type: string, text: string) => void;
  chkReload: (type: string) => void;
  userId: string;
  handleLoadingTable: (load: boolean) => void;
}
interface LocationState {
  reload?: boolean;
}

export const FilterBatchProcessFile: React.FC<Props> = ({
  filter,
  userId,
  chkReload,
  handleLoadingTable,
  accessRole,
}) => {
  const location = useLocation<LocationState>();

  useEffect(() => {
    if (location.state?.reload) {
      console.log("test");

      handleLoadingTable(true);
    }
  }, [location.state]);
  const checkAccessRole = (role: string) => {
    var result = accessRole.indexOf(role) > -1;
    if (result == true) {
      return true;
    } else {
      return false;
    }
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { tokenAccess, login, logout, id24Axios } = useId24();
  // const apiBaseUrlUser = id24Axios(appConfig.apiBaseUrlUser);
  const apiBaseUrlDatalink = id24Axios(appConfig.apiBaseUrlDatalink);

  const [form] = Form.useForm();
  const [getrmId, setrmId] = useState<number>(0);
  const [getJobs, setJobs] = useState<any>([]);
  const [getpsDate, setpsDate] = useState<any>("");
  // const [getscheduleName, setscheduleNmae] = useState<string>("");
  const [joblDailys, setJoblDailys] = useState<
    {
      categoryService: string;
      opt: { value: string; label: string; rmId: number }[];
    }[]
  >([]);
  const [selectedJoblDaily, setSelectedJoblDaily] = useState<
    | {
        categoryService: string;
        opt: { value: string; label: string; rmId: number }[];
      }
    | undefined
  >(undefined);
  // const handleselectschedulename = (e: number) => {
  //   if (e) {
  //     setrmId(e);
  //     if (e === 1) {
  //       setscheduleNmae("import-cbs");
  //     } else {
  //       setscheduleNmae("cardlink");
  //     }
  //   }
  // };

  const showModal = async () => {
    await fetchJobsData();
    setIsModalVisible(true);
    form.resetFields();
  };
  const fetchJobsData = async () => {
    const data: any[] =
      (await BatchProcessServiceDailyFile(apiBaseUrlDatalink).getAllDaily()) ||
      ([] as any[]);
    const grouped = data
      .filter((item) => item.active)
      .reduce<
        Record<
          string,
          {
            categoryService: string;
            opt: { value: string; label: string; rmId: number }[];
          }
        >
      >((acc, item) => {
        const key = item.categoryService;
        if (!acc[key]) {
          acc[key] = { categoryService: key, opt: [] };
        }
        acc[key].opt.push({
          value: item.details,
          label: item.fileName,
          rmId: item.rmId,
        });
        return acc;
      }, {});

    const result = Object.values(grouped);
    setJoblDailys(result);
  };
  const handleSelectDailycategory = (value: string) => {
    const data = joblDailys.find((job) => job.categoryService === value);
    data ? setSelectedJoblDaily(data) : setSelectedJoblDaily(undefined);
  };
  const onFinishAdd = async (values: any) => {
    const conTimeOption = {
      psDate: dayjs(getpsDate).format("YYYY-MM-DD"),
      start: {
        hour: moment(values.timeOption).format("HH"),
        minute: moment(values.timeOption).format("mm"),
      },
      end: {
        hour: moment(values.timeOption).format("HH"),
        minute: moment(values.timeOption).format("mm"),
      },
    };
    // const conJobs = JSON.parse(values.jobs);
    const data = {
      rmId: getrmId,
      fileName: values.fileName,
      psDate: dayjs(getpsDate).format("YYYY-MM-DD"),
      processType: selectedJoblDaily?.categoryService,
      details: getJobs,
      jobs: [
        { jobType: "file-transfer", option: getrmId },
        { jobType: selectedJoblDaily?.categoryService, option: getJobs },
      ],
      timeOption: conTimeOption,
    };
    // console.log(data);
    const res: any = await BatchProcessFileService(apiBaseUrlDatalink).addFile(
      data,
    );
    if (res) {
      message.success("เพิ่มข้อมูลเรียบร้อย");
      setIsModalVisible(false);
      handleLoadingTable(true);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setrmId(0);
    form.resetFields();
  };

  function handleSelectDaily(event: string): void {
    setJobs(event);
    const rmId = selectedJoblDaily?.opt.find(
      (opt) => opt.value === event,
    )?.rmId;
    setrmId(rmId || 0);
  }

  return (
    <>
      <Row>
        <Col span={8}>
          <Typography.Title level={5} style={{ textAlign: "left" }}>
            File Process
          </Typography.Title>
        </Col>
        {checkAccessRole("ddebtSettingBatchProcessFileAction") ? (
          <Col span={16}>
            <div style={{ textAlign: "right" }}>
              <Space size={"small"}>
                <Button type="primary" onClick={showModal}>
                  + Add Job
                </Button>
                <Modal
                  title="Add Job"
                  open={isModalVisible}
                  onCancel={handleCancel}
                  footer={[]}
                  width={1200}
                >
                  <Form
                    form={form}
                    autoComplete="off"
                    name="addjobsform"
                    labelCol={{ span: 5 }}
                    wrapperCol={{ span: 17 }}
                    onFinish={onFinishAdd}
                    onFinishFailed={onFinishFailed}
                    fields={[
                      {
                        name: ["id"],
                        value: uuidv4(),
                      },
                    ]}
                  >
                    <Form.Item hidden={true} label="ID" name="id">
                      <Input placeholder="id" style={{ width: "90%" }} />
                    </Form.Item>
                    <Form.Item
                      label="Remote Account"
                      name="rmId"
                      rules={[
                        {
                          required: true,
                          message: "Please input Name",
                        },
                      ]}
                    >
                      {/* <Select
                        placeholder={"Please Select"}
                        onChange={(data: any) => handleselectschedulename(data)}
                      >
                        <Option key={0} value={0} disabled>
                          Please Select
                        </Option>
                        <Option key={1} value={1}>
                          CBS
                        </Option>
                        <Option key={2} value={3}>
                          Card Link
                        </Option>
                      </Select> */}
                      <Select
                        options={joblDailys.map((data) => ({
                          value: data.categoryService,
                          label: data.categoryService,
                        }))}
                        placeholder={"Please Select"}
                        onChange={(data: any) =>
                          handleSelectDailycategory(data)
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      label="File Name"
                      name="fileName"
                      rules={[
                        {
                          required: true,
                          message: "Please input fileName",
                        },
                      ]}
                    >
                      <Input
                        id="fileName"
                        placeholder="Filename"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Process Date"
                      name="psDate"
                      rules={[
                        {
                          required: true,
                          message: "Please input psDate",
                        },
                      ]}
                    >
                      <DatePicker
                        locale={datePickerTh}
                        disabledDate={(current: any) => {
                          return moment().add(-1, "days") >= current;
                        }}
                        value={getpsDate}
                        id="psDate"
                        name="psDate"
                        style={{ width: "30%" }}
                        format={"DD-MM-BBBB"}
                        onChange={(e: any) => setpsDate(e)}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Run Time"
                      name="timeOption"
                      rules={[
                        {
                          required: true,
                          message: "Please input timeOption",
                        },
                      ]}
                    >
                      <TimePicker
                        popupStyle={{ fontSize: 12 }}
                        format={format}
                        style={{ width: "30%" }}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Jobs"
                      name="jobs"
                      rules={[
                        {
                          required: true,
                          message: "Please input jobs",
                        },
                      ]}
                    >
                      {!selectedJoblDaily ? (
                        <Select disabled placeholder={"Please Select"}></Select>
                      ) : (
                        <Select
                          placeholder={"Please Select"}
                          onChange={(event: any) => handleSelectDaily(event)}
                          allowClear
                          options={selectedJoblDaily.opt}
                        />
                      )}
                    </Form.Item>
                    <Space
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        key="save"
                        type="primary"
                        htmlType="submit"
                        style={{ width: "80px" }}
                      >
                        Save
                      </Button>
                      <Button
                        key="cancel"
                        onClick={handleCancel}
                        style={{ width: "80px" }}
                      >
                        Cancel
                      </Button>
                    </Space>
                  </Form>
                </Modal>
              </Space>
            </div>
          </Col>
        ) : (
          <></>
        )}
      </Row>
    </>
  );
};
